import _DirectionsCar from "@mui/icons-material/DirectionsCar";
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
export function CarRoutePopup({
  theme
}) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_DirectionsCar, {
    fontSize: "large"
  })));
}